import { useSelector } from 'react-redux'
import { StateExtended } from '../../_config/interfaces/stateExtended'


export function useAuthStatus() {
  const isAuthenticated = useSelector((state: StateExtended) => state.user.isAuthenticated)
  return isAuthenticated
}

export function useStoreSelector() {
  const store = useSelector((state: StateExtended) => state.user ? state.user.store :  null)
  return store
}

export function useStoreBrnDSSelector() {
  const branchDS = useSelector((state: StateExtended) => state.user ? state.user.branchDS :  null)
  return branchDS
}

export function useLoginCodeSelector() {
  const loginCode = useSelector((state: StateExtended) => state.user ? state.user.loginCode :  null)
  return loginCode
}

export function useBranchRefreshTimestampSelector() {
  const branchRefreshTimestamp = useSelector((state: StateExtended) => state.user ? state.user.branchRefreshTimestamp : null)
  return branchRefreshTimestamp
}

export function useModulesSelector() {
  const modules = useSelector((state: StateExtended) => state.user ? state.user.modules : null)
  return modules
}

export function useCompanyLogoSelector() {
  const companyLogo = useSelector((state: StateExtended) => state.user?.company?.company_logo || null)
  return companyLogo
}
